// Asset path configuration
// Change this base path to match your deployment location
const BASE_PATH = process.env.PUBLIC_URL || '';

export const ASSET_PATHS = {
  // Base paths
  IMAGES: `${BASE_PATH}/assets/images`,
  SVGS: `${BASE_PATH}/assets/svgs`,

  // SVG categories
  DINOSAURS: `${BASE_PATH}/assets/svgs/dinosaurs`,
  CRYPTIDS: `${BASE_PATH}/assets/svgs/cryptids`,
  CARTOON: `${BASE_PATH}/assets/svgs/cartoons`,
  VEHICLES: `${BASE_PATH}/assets/svgs/vehicles`,
  ANIMALS: `${BASE_PATH}/assets/svgs/animals`,
  MILITARY: `${BASE_PATH}/assets/svgs/police-fire-military`,
  SPACE: `${BASE_PATH}/assets/svgs/space`,
  OUTDOOR: `${BASE_PATH}/assets/svgs/outdoor`,
  OFFROAD: `${BASE_PATH}/assets/svgs/offroad`,
  POP_CULTURE: `${BASE_PATH}/assets/svgs/pop-culture`,
  VEHICLES_POP: `${BASE_PATH}/assets/svgs/vehicles-pop-culture`,

  // Specific assets
  LOGO: `${BASE_PATH}/assets/svgs/clothedEye.svg`,
  WATERMARK: `${BASE_PATH}/assets/svgs/clothedEye-watermark.svg?v=${Date.now()}`, // Use the proper watermark file with cache busting
  TAGLINE: `${BASE_PATH}/assets/svgs/clothedEye_BMDITS.svg`,
  TRUESCALE_LOGO: `${BASE_PATH}/assets/images/trueScale.png`, // Only PNG exists
  TRUESCALE_PNG: `${BASE_PATH}/assets/images/trueScale.png`,

  // Background images
  BKG_DINO: `${BASE_PATH}/assets/images/bkg-dino.jpg`,
  BKG_DINO_PARALLAX: `${BASE_PATH}/assets/images/bkg-dino-parallax.jpg`,
  BKG_CRYPTID: `${BASE_PATH}/assets/images/bkg-cryptid.jpg`,
  BKG_MILITARY: `${BASE_PATH}/assets/images/bkg-military.jpg`,
  BKG_CARTOON: `${BASE_PATH}/assets/images/bkg-cartoon.jpg`,
  BKG_GENERIC: `${BASE_PATH}/assets/images/bkg-generic.jpg`,
  BKG_HORROR: `${BASE_PATH}/assets/images/bkg-horror.jpg`,

  // Collection images
  COLLECTION_BASE: `${BASE_PATH}/assets/images/collection-`,

  // Background selector images
  BG_CAR: `${BASE_PATH}/assets/images/bg-car-window.jpg`,
  BG_LAPTOP: `${BASE_PATH}/assets/images/bg-laptop.jpg`,
  BG_DESK: `${BASE_PATH}/assets/images/bg-desk.jpg`,

  // Shopping cart icon
  SHOPPING_CART: `${BASE_PATH}/assets/svgs/shopping_cart_checkout.svg`,
};

// Helper function to get any asset path safely
export const getAssetPath = (assetKey) => {
  return ASSET_PATHS[assetKey] || `${BASE_PATH}/assets/missing.svg`;
};

export const getBackgroundImage = (category) => {
  const backgroundMap = {
    dinosaurs: ASSET_PATHS.BKG_DINO,
    cryptids: ASSET_PATHS.BKG_CRYPTID,
    cartoon: ASSET_PATHS.BKG_CARTOON,
    'police-fire-military': ASSET_PATHS.BKG_MILITARY,
    vehicles: ASSET_PATHS.BKG_CARTOON,
    offroad: ASSET_PATHS.BKG_GENERIC,
    'vehicles-pop-culture': ASSET_PATHS.BKG_CARTOON,
    animals: ASSET_PATHS.BKG_GENERIC,
    outdoor: ASSET_PATHS.BKG_GENERIC,
    'pop-culture': ASSET_PATHS.BKG_HORROR,
    space: ASSET_PATHS.BKG_GENERIC,
  };

  return backgroundMap[category] || ASSET_PATHS.BKG_GENERIC;
};

export const getCollectionImage = (category) => {
  // Map of categories to their actual collection image filenames
  const slugMap = {
    Dinosaurs: 'dino',
    Cryptids: 'cryptid',
    Cartoon: 'cartoon',
    'Police/Fire/Military': 'military',
    Vehicles: 'vehicles',
    Animals: 'animals',
    'Pop Culture': 'popculture',
    Space: 'space',
    'Vehicles Pop Culture': 'vehicles',
    Holiday: 'holiday',
    Horror: 'horror',
    'Horror Classic': 'horror-classic',
    Outdoor: 'outdoor',
    Offroad: 'offroad',
    'Offroad Slogans': 'offroad-slogans',
  };

  const slug = slugMap[category];

  // Return null if no collection image exists for this category
  if (!slug) {
    return null;
  }

  return `${ASSET_PATHS.COLLECTION_BASE}${slug}.png`;
};

export function getSvgPath(category, filename) {
  // Map category names to folder names
  const categoryFolderMap = {
    Dinosaurs: 'dinosaurs',
    Cryptids: 'cryptids',
    Cartoon: 'cartoons',
    'Police/Fire/Military': 'police-fire-military',
    Vehicles: 'vehicles',
    Animals: 'animals',
    'Pop Culture': 'pop-culture',
    Space: 'space',
    Outdoor: 'outdoor',
    Offroad: 'offroad',
    'Vehicles Pop Culture': 'vehicles-pop-culture',
  };
  const folder = categoryFolderMap[category] || category.toLowerCase().replace(/\s+/g, '-');
  return `${BASE_PATH}/assets/svgs/${folder}/${filename}`;
}
